import { render, staticRenderFns } from "./frmegeszsegkartya.vue?vue&type=template&id=3c423eaf&"
import script from "./frmegeszsegkartya.vue?vue&type=script&lang=js&"
export * from "./frmegeszsegkartya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports